/**
 * productId:
 * timestamp:
 * seqId: // 用于标示事件顺序的字段， 从app安装开始， 单调递增
 * url:
 * net:
 * keyValues: [
 *      {
 *          key:
 *          value:
 *      }
 * ]
 *
 * 说明:
 *  1. seqId 对于Web端来说是无用且很难保证准确的数据,故而不填
 */
import { NET_TYPES } from '../constants';
import QueryUtil from '../utils/QueryUtil';
var query = QueryUtil.search() || {};
var REG_QUERY = /(?:^|&)([^&=#]+)=?([^&#]+)?/g;
var Entry = /** @class */ (function () {
    function Entry(config) {
        this.initKeyValues = [];
        this.config = config;
        this.setInitKeyValues();
    }
    Entry.prototype.getData = function (url) {
        var data = {
            productId: this.productId,
            timestamp: new Date().getTime(),
            url: this.getUrlPrefix(url),
            keyValues: this.getKeyValues(url),
            net: this.net,
        };
        // key只在存储的时候用，JSON.stringify的时候会被忽略掉
        return Object.defineProperty(data, 'key', {
            get: function () {
                return this.url + '/' + this.timestamp;
            },
            configurable: false,
            enumerable: false,
        });
    };
    Object.defineProperty(Entry.prototype, "productId", {
        get: function () {
            return this.config.productId || 351; // tutor
        },
        enumerable: true,
        configurable: true
    });
    Entry.prototype.setInitKeyValues = function () {
        this.initKeyValues = this.config.keyValues || [];
        var _a = this.config, _b = _a.keyfrom, keyfrom = _b === void 0 ? query.keyfrom || '' : _b, _c = _a.vendor, vendor = _c === void 0 ? query.vendor || '' : _c;
        keyfrom && this.addKeyValue('keyfrom', keyfrom);
        vendor && this.addKeyValue('vendor', vendor);
    };
    Entry.prototype.getUrlPrefix = function (url) {
        if (url === void 0) { url = ''; }
        return url.split('?')[0];
    };
    Entry.prototype.getUrlKeyValues = function (url) {
        if (url === void 0) { url = ''; }
        var _a = url.split('?'), _b = _a[1], urlParamString = _b === void 0 ? '' : _b;
        var keyValues = [];
        if (urlParamString) {
            urlParamString.replace(REG_QUERY, function (_$0, key, value) {
                keyValues.push({
                    key: key,
                    value: value,
                });
                return '';
            });
        }
        return keyValues;
    };
    Entry.prototype.getKeyValues = function (url) {
        var keyValueMap = {};
        this.initKeyValues.forEach(function (keyValue) {
            keyValueMap[keyValue.key] = keyValue.value;
        });
        this.getUrlKeyValues(url).forEach(function (keyValue) {
            keyValueMap[keyValue.key] = keyValue.value;
        });
        return Object.keys(keyValueMap).map(function (key) {
            return {
                key: key,
                value: keyValueMap[key],
            };
        });
    };
    Entry.prototype.addKeyValue = function (key, value) {
        if (key && value) {
            this.initKeyValues.push({
                key: key,
                value: value,
            });
        }
    };
    Object.defineProperty(Entry.prototype, "net", {
        get: function () {
            var netType = '';
            var len = 4;
            // @ts-ignore
            var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
            if (connection && connection.type) {
                netType = connection.type;
            }
            else if (/NetType\/(\S+)/.test(navigator.userAgent)) {
                netType = RegExp.$1;
            }
            if (netType && 'string' === typeof netType) {
                netType = netType.toLowerCase();
                while (len--) {
                    // netType may be a long name that include one of NET_TYPES
                    if (netType.indexOf(NET_TYPES[len]) > -1) {
                        return len + 1;
                    }
                }
            }
            return 0;
        },
        enumerable: true,
        configurable: true
    });
    return Entry;
}());
export default Entry;
